import React, { useState, useEffect } from "react";
import "./AttendanceFilter.css";

const AttendanceFilter = ({ visible, onClose, onApply }) => {
  const [sortOrder, setSortOrder] = useState("");

  useEffect(() => {
    if (!visible) {
      setSortOrder("");
    }
  }, [visible]);

  if (!visible) return null;

  const handleApply = () => {
    onApply({
      sortBy: "attendanceDate",
      sortOrder: sortOrder
    });
    onClose();
  };

  const handleClear = () => {
    // 1. Local state reset panrom
    setSortOrder("");
    
    // 2. Parent component table-ah reset panna empty value anupuroam (optional but recommended)
    onApply({
      sortBy: "attendanceDate",
      sortOrder: "" 
    });

    // 3. Filter modal-ah close panrom
    onClose(); 
  };

  return (
    <div className="fm-overlay" onClick={onClose}>
      <div
        className="fm-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fm-header">Filter</div>

        <div className="fm-body">
          <label className="fm-label">Sort By</label>
          <select
            className="fm-select"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="">Select</option>
            <option value="DESC">Newest</option>
            <option value="ASC">Oldest</option>
          </select>
        </div>

        <div className="fm-footer">
          <button className="fm-btn fm-clear" onClick={handleClear}>
            Clear
          </button>

          <button className="fm-btn fm-apply" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttendanceFilter;